import { useMemo } from 'react';
import { useCallContext } from './hooks/use-context';

export const useKlwReadOnly = (): boolean => {
  const callContext = useCallContext();

  return useMemo(() => {
    if (!callContext.data) return true;
    const { gebruikerIsAuthorized, gebruikerIsDeelnemer, kringloopwijzerStatusId, volmacht } = callContext.data;
    if (kringloopwijzerStatusId > 1) return true;
    if (gebruikerIsDeelnemer) return false;
    if (volmacht) return false;
    if (gebruikerIsAuthorized) return false;
    return true;
  }, [callContext]);
};
